import axios from "axios";
import { format, setHours, setMinutes, setSeconds, subDays } from "date-fns";
import moment from "moment";
import { LOD1 } from "utilFunctions/Constants/Constants";
export default function hasObjectHasNullValues(obj: any): boolean {
  for (const key in obj) {
    if (obj[key] !== null) {
      return true;
    }
  }
  return false;
}
export const roundToAnyDecimalPlaces = (
  number: number,
  uptoDecimal: number
): number => {
  return Number(number.toFixed(uptoDecimal));
};
export const capitalizeWords = (str: string) => {
  if (typeof str !== "string" || !str) return "";
  return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};
export const capitalizeFirstCharaterOfString = (name: string) => {
  if (typeof name !== "string" || !name) return "";
  return name
    .trim()
    .split(" ")
    .map((word: any) => (word ? word[0].toUpperCase() : ""))
    .join("");
};
export const removeSubChildrenFromNodes = (arr: any) => {
  return arr.filter((item: any) => {
    if (item.nodeType === "Sub-Sub-Topic") {
      return false; // Remove Sub-Sub-Topic nodes
    }
    if (item.children) {
      item.children = removeSubChildrenFromNodes(item.children); // Recursively remove from children
    }
    return true;
  });
};
export function calculatePercentage(value: number, total: number): number {
  return (value / total) * 100;
}
export const convertCamelCaseToTitle = (str: string) => {
  const titleCase = str.replace(/([A-Z])/g, " $1").trim();
  return titleCase.charAt(0).toUpperCase() + titleCase.slice(1);
};
export function removeDuplicates(arr: any) {
  return arr.filter((value: any, index: any, self: any) => {
    return self.indexOf(value) === index;
  });
}
export const returnStartAndEndDate = (
  dateRanges: any,
  beforeDay: number,
  afterDay: number
) => {
  const startDate = format(
    setSeconds(
      setMinutes(
        setHours(subDays(new Date(dateRanges[0].startDate), beforeDay), 18),
        30
      ),
      0
    ),
    "yyyy-MM-dd HH:mm:ss"
  );
  const endDate = format(
    setSeconds(
      setMinutes(setHours(new Date(dateRanges[0].endDate), afterDay), 30),
      0
    ),
    "yyyy-MM-dd HH:mm:ss"
  );
  return { startDate, endDate };
};
export const getAllNodes = (array: any[]) => {
  const newArr: any = [];
  array.map((ele) => {
    if (ele["children"] && ele["children"].length > 0) {
      newArr.push(...getAllNodes(ele["children"]));
    }
    newArr.push(ele);
  });
  return newArr;
};
export function fnBrowserDetect() {
  const userAgent = navigator.userAgent;
  let browserName;
  if (userAgent.match(/edg/i)) {
    browserName = "edge";
  } else if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "opera";
  } else {
    browserName = "No browser detection";
  }
  return browserName;
}
export const returnTimeInMiliseconds = (date: any) => {
  return moment(date).valueOf();
};
export const getLod1 = (value = "NA") => {
  const filterdata = LOD1.find((item: any) => {
    return item.value == value;
  });
  return filterdata != undefined ? filterdata.label : "";
};

export const returnEditedRow = (fieldsKeys: any = {}, key = "NA") => {
  const newObj: any = {};
  Object.keys(fieldsKeys).map((item) => {
    if (item.endsWith(key)) {
      const leng = key.length;
      const newKey = item.slice(0, item.length - leng);
      newObj[newKey] = fieldsKeys[item];
    }
  });
  return newObj;
};
export const returnValidateEditedRow = (fieldsKeys: any = {}, key = "NA") => {
  const newObj: any = {};
  Object.keys(fieldsKeys).map((item) => {
    if (item.endsWith(key)) {
      newObj[item] = fieldsKeys[item];
    }
  });
  return newObj;
};
const removeDuplicatesElements = (array: any = []) => {
  const obj: any = {};
  const newArr: any = [];
  array.forEach((ele: any) => {
    if (!obj[ele.questionId]) {
      obj[ele.questionId] = ele.questionId;
      newArr.push(ele);
    }
  });
  return newArr;
};
export const handleSelectAll = (
  selected: any,
  selectedRows: any = [],
  changeRows: any,
  setQIdKey: any
) => {
  const filterRows = selectedRows.filter((ele: any) => ele !== undefined);
  if (!filterRows.length) {
    setQIdKey((prev: any) => {
      const changeRowsValues = changeRows.map((ele: any) => ele.questionId);
      const prevFilter = prev.filter(
        (ele: any) => !changeRowsValues.includes(ele.questionId)
      );
      return removeDuplicatesElements([...prevFilter, ...filterRows]);
    });
  } else {
    setQIdKey((prev: any) => {
      return removeDuplicatesElements([...prev, ...filterRows]);
    });
  }
};
export const handleRowSelect = (
  record: any,
  selected: any,
  selectedRows: any = [],
  setQIdKey: any
) => {
  const { questionId } = record || {};
  const filterRows = selectedRows.filter((ele: any) => ele !== undefined);
  setQIdKey((prev: any) => {
    const prevValue = selected
      ? prev
      : prev.filter((ele: any) => ele && ele.questionId !== questionId);
    return removeDuplicatesElements([...prevValue, ...filterRows]);
  });
};
export const uploadFileToS3 = async (url: string, file: any) => {
  try {
    const contentType = (file as any)?.type || "application/pdf";
    console.log("Uploading to S3 with Content-Type:", contentType);
    await axios.put(url, file, {
      headers: {
        "Content-Type": contentType,
      },
    });
    console.log("S3 upload successful");
  } catch (error: any) {
    console.error(
      "S3 upload error details:",
      error.response?.data || error.message
    );
    throw error;
  }
};
